import type { RefObject } from 'react';
import ReactCountryFlag from 'react-country-flag';

import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { SDSText } from '@repo/sds/SDSText';

import type { Country } from '../../constants/countries';

import './CountryListItem.scss';

import { DataTestIds } from '@repo/frontend-shared/data-test-ids';

interface CountryListItemProps {
  itemRef?: RefObject<HTMLButtonElement | null> | null;
  country: Country;
  onClick: (country: Country) => void;
  isSelected: boolean;
  showFlag?: boolean;
}

export function CountryListItem({ itemRef, country, onClick, showFlag = true }: CountryListItemProps) {
  const handleClick = () => {
    onClick(country);
  };

  return (
    <SDSPrimitiveButton
      className="CountryListItem"
      onClick={handleClick}
      buttonRef={itemRef}
      dataTestId={DataTestIds.COMMON.DROPDOWN_ITEM}
    >
      {showFlag && <ReactCountryFlag countryCode={country.code} svg aria-label={country.name} />}
      <SDSText type="body-medium" text={country.name} />
    </SDSPrimitiveButton>
  );
}
